/**
 * Generated runtime TestId mirror for frontend/src/components/observability/SpanDetailSheet.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SpanDetailSheetTestIds = {
  attributesJson: "attributes-json",
  btnViewErrorLog: "btn-view-error-log",
  linkViewErrorLog: "link-view-error-log",
  spanDetailSheet: "span-detail-sheet",
  tabAttributes: "tab-attributes",
  tabError: "tab-error",
  tabHttp: "tab-http",
  tabOverview: "tab-overview",
  tabSql: "tab-sql"
} as const;
